import { Component, OnInit, Inject } from '@angular/core';

import { DatePipe } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from '../../../_common/_service/authservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-confirm-banktransfer-dialog',
  templateUrl: './confirm-banktransfer-dialog.component.html',
  styleUrls: ['./confirm-banktransfer-dialog.component.scss']
})
export class ConfirmbanktransferDialogComponent implements OnInit {

  beneficiary_serviceName: any;
  beneficiary_country: any;
  channel: any;
  beneficiary_phone: any;
  beneficiary_fname: any;
  beneficiary_lname: any;
  beneficiary_email: any;
  beneficiary_id: any;
  beneficiary_id_number: any;
  beneficiary_nationality: any;
  beneficiary_relationship: any;
  beneficiary_type: any;
  countrycode: any;
  editId: any;
  serviceCode: any;
  countrytxt: any;
  beneficiary_account_no: any;

  constructor(private authService: AuthService, private router: Router, private toastr: ToastrService,
    private route: ActivatedRoute, public dialogRef: MatDialogRef<ConfirmbanktransferDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
    debugger;
    this.serviceCode = this.route.snapshot.queryParams.serviceCode;
    this.editId = this.data.editId;

    this.beneficiary_id = this.data.beneficiary_id;
    this.beneficiary_serviceName = this.data.beneficiary_serviceName;
    //this.beneficiary_country = this.data.beneficiary_country;
    //this.channel = this.data.channel;
    this.beneficiary_phone = this.data.beneficiary_phone;
    this.beneficiary_fname = this.data.beneficiary_fname;
    this.beneficiary_lname = this.data.beneficiary_lname;

    this.beneficiary_email = this.data.beneficiary_email;
    this.beneficiary_id = this.data.beneficiary_id;
    this.beneficiary_id_number = this.data.beneficiary_id_number;
    this.beneficiary_nationality = this.data.beneficiary_nationality;
    this.beneficiary_relationship = this.data.beneficiary_relationship;
    this.beneficiary_type = this.data.beneficiary_type;
    this.countrycode = this.data.beneficiary_country_Accountcode;
    this.countrytxt = this.data.beneficiary_country;
    this.beneficiary_account_no = this.data.beneficiary_account_no;
    this.channel = this.data.beneficiary_bank_name;
  }

  done() {
    this.dialogRef.close();
  }

  closeModal() {
    this.dialogRef.close();
  }


  BeneficiaryInfoEDITbyId() {
    ;
    this.router.navigate(['/EditBanktransferBeneficiary'], { queryParams: { serviceCode: this.serviceCode, editId: this.editId, countryCode: this.countrycode }, skipLocationChange: true });
    //this.router.navigate(['/MobileMoneBeneficiary'], { state: { editId: this.editId } });

    //this.router.navigate(['/MobileMoneBeneficiary/SMA?id=' + this.editId]);
    //this.authService.GetMobileMoneyBeneficiaryDetailsbyId(this.editId).subscribe(response => {
    //  ;

    //  // this.openBeneficiaryDialog(response[0]);

    //}, (err: any) => {
    //  if (err.error instanceof Error) {
    //    this.toastr.error(err.error, 'Error');
    //  } else {
    //    this.toastr.error(err.error, 'Error');
    //  }
    //}
    //);

  }

  BeneficiaryInfoDELETEbyId() {
    
    this.authService.BeneficiaryInfoDELETEbyId(this.editId).subscribe(response => {
      debugger
      if (response.apiStatus == true) {
      
        this.toastr.success(response.apiMessage, 'Success');
        this.dialogRef.close();
        window.location.reload();
      }
      else {
        this.toastr.error(response.apiMessage, 'Error');
      }
      // this.openBeneficiaryDialog(response[0]);

    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {
        this.toastr.error(err.error, 'Error');
      }
    }
    );

  }
}
